<template>
    <div class="page-landing">
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-primary shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3 text-white"><span>Universal</span> e-insurance system</h1>
                                <p class="lead text-white">
                                  The online insurance service simplifies the procedure for concluding a contract as much as possible.
                                </p>
                                <div class="btn-wrapper">
                                    <router-link
                                            to="/contacts"
                                            class="btn btn-neutral"
                                    >Contact us</router-link>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 order-md-2 text-right hide-xs">
                                <img v-lazy="'img/theme/logo@3x.png'" class="figure">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-like-2" type="primary" rounded class="mb-4"></icon>
                                    <h6 class="text-primary text-uppercase">Ease of use</h6>
                                    <p class="description mt-3">
                                      You only think about the insurance business, and technical issues are handled by the AIWA team.</p>
                                    <div>
                                        <badge type="primary" rounded>price</badge>
                                        <badge type="primary" rounded>lightness</badge>
                                        <badge type="primary" rounded>professionals</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button>-->
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-key-25" type="warning" rounded class="mb-4"></icon>
                                    <h6 class="text-warning text-uppercase">Information Security</h6>
                                    <p class="description mt-3">
                                      All our AIWA.Cloud servers comply with modern security and data privacy standards.</p>
                                    <div>
                                        <badge type="warning" rounded>encryption</badge>
                                        <badge type="warning" rounded>EDS</badge>
                                        <badge type="warning" rounded>GDPR</badge>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-app" type="success" rounded class="mb-4"></icon>
                                    <h6 class="text-success text-uppercase">Flexibility in integration</h6>
                                    <p class="description mt-3">
                                      Convenient widgets for online sales and API allow you to solve almost any integration task.</p>
                                    <div>
                                        <badge type="success" rounded>widgets</badge>
                                        <badge type="success" rounded>support</badge>
                                        <badge type="success" rounded>API</badge>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/promo-1.png" alt="Customizing" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon
                                    name="ni ni-badge"
                                    class="mb-5"
                                    size="lg"
                                    type="success"
                                    shadow
                                    rounded
                            ></icon>
                            <h3>Yours in everything</h3>
                            <p>
                              The first is your system.
                              Get started on a rental basis and buy a copy of AIWA at any time.
                              AIWA team will always be happy to help develop your own solution if required.
                            </p>
                            <p>Already from the first step you are available:</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge
                                                type="success"
                                                circle
                                                class="mr-3"
                                                icon="ni ni-laptop"
                                        ></badge>
                                        <h6 class="mb-0">Your domain name</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge
                                                type="success"
                                                circle
                                                class="mr-3"
                                                icon="ni ni-palette"
                                        ></badge>
                                        <h6 class="mb-0">Your and your partners' corporate identity</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge
                                                type="success"
                                                circle
                                                class="mr-3"
                                                icon="ni ni-satisfied"
                                        ></badge>
                                        <h6 class="mb-0">Friendly technical support</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-info shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" alt="R and D" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon
                                        name="ni ni-spaceship"
                                        size="lg"
                                        class="bg-gradient-white"
                                        color="info"
                                        shadow
                                        rounded
                                ></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Continuous progress</h4>
                                <p class="text-white">
                                  The first version of AIWA was released in 2008 and&nbsp;since then our team has become even more experienced both in the&nbsp;insurance industry and in the&nbsp;technical aspects of online solutions.</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon
                                            name="ni ni-satisfied"
                                            gradient="success"
                                            color="white"
                                            shadow
                                            rounded
                                    ></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Partner satisfaction</h5>
                                    <p>During our joint work, some of our partners have grown to market leaders.
                                      We continue to cooperate today.</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon
                                            name="ni ni-active-40"
                                            gradient="default"
                                            color="white"
                                            shadow
                                            rounded
                                    ></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-default">Business accents</h5>
                                    <p>Work in dialogue only. We offer more optimal IT solutions, and our partners develop an insurance infrastructure.</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">
                          Electronic document management has&nbsp;become a&nbsp;requirement for a&nbsp;successful&nbsp;business and
                            <span class="text-success">AIWA is optimal choice.</span>
                        </h2>
                        <p class="lead">
                          E-insurance works around the clock and seven days a week.
                          Everyone can order an insurance policy or conclude an agreement directly on the site.
                          <br/>At the same time, an absolutely reliable security system will allow you to pay for insurance using a payment card online.
                        </p>
                        <div class="btn-wrapper">
                            <router-link
                                    to="/contacts"
                                    class="btn btn-primary mb-3 mb-sm-0"
                            >Find out more
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="row justify-content-center text-center">
                    <div class="col-lg-3 col-md-4">
                        <router-link to="/online" class="px-2">
                            <div
                                    class="icon icon-shape bg-gradient-primary rounded-circle text-white"
                            >
                                <i class="ni ni-basket"></i>
                            </div>
                            <span class="d-block mt-3 text-primary">Online platform</span>
                        </router-link>
                    </div>
                    <div class="col-lg-3 col-md-4">
                        <router-link to="/for-agents" class="px-2">
                            <div
                                    class="icon icon-shape bg-gradient-success rounded-circle text-white"
                            >
                                <i class="ni ni-briefcase-24"></i>
                            </div>
                            <span class="d-block mt-3 text-success">Agent's office</span>
                        </router-link>
                    </div>
                    <div class="col-lg-3 col-md-4">
                        <router-link to="/api" class="px-2">
                            <div
                                    class="icon icon-shape bg-gradient-warning rounded-circle text-white"
                            >
                                <i class="ni ni-vector"></i>
                            </div>
                            <span class="d-block mt-3 text-warning">Interaction API</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
	export default {
		name      : "home",
		components: {}
	};
</script>
